/* eslint-disable */
export const region4aBarangays = [
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'BINAGBAG',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'DAYAP',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'IBABANG KINAGUNAN',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'ILAYANG KINAGUNAN',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'KANLURANG CALUTAN',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'KANLURANG MALIGAYA',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'SILANGANG CALUTAN',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'SILANGANG MALIGAYA',
    },
    {
        CITY: 'AGDANGAN',
        BARANGAY: 'SILDORA',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'ANGELES',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'BALUNGAY',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'CAGLATE',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'CAMAGONG',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'GORDON',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'PAMBILAN NORTE',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'PAMBILAN SUR',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'VILLA ESPERANZA',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'VILLA JESUS ESTE',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'VILLA JESUS WESTE',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'VILLA NORTE',
    },
    {
        CITY: 'ALABAT',
        BARANGAY: 'VILLA VICTORIA',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'ANGELES',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'BALUBAD',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'BALUGOHIN',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'BARANGAY ZONE 1 (POB.)',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'BARANGAY ZONE 2 (POB.)',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'BARANGAY ZONE 3 (POB.)',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'BARANGAY ZONE 4 (POB.)',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'BUHANGIN',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'CARIDAD IBABA',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'CARIDAD ILAYA',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'HABINGAN',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'INACLAGAN',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'INALIG',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'KILAIT',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'KULAWIT',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'LAKIP',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'LUBI',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'LUMUTAN',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'MALINAO IBABA',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'MALINAO ILAYA',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'MALUSAK',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'MANGGALAYAN BUNDOK',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'MANGGALAYAN LABAK',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'MATANAG',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'MONTES BALAON',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'MONTES KALLAGAN',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'PONON',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'SAN ANDRES BUNDOK',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'SAN ANDRES LABAK',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'SAN JOSE BALATOK',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'SAPAAN',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'SOKOL',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'TAGBAKIN',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'TALABA',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'TINANDOG',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'VILLA IBABA',
    },
    {
        CITY: 'ATIMONAN',
        BARANGAY: 'VILLA ILAYA',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'ALUYON',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'AMOT',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'ANIBAWAN',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'CABUNGALUNAN',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'CALUTCOT',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'CANIWAN',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'CARLAGAN',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'PALASAN',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BURDEOS',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'AGOHO',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'ANAHAWAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'ANAS',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'APAD LUTAO',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'APAD QUEZON',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'APAD TAISAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'ATULAYAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BACLARAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BALIBAGO',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BANGKURUHAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BANTOLINAO',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BIGAAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BINUTAS',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BIYAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'BULI',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'DOMINLOG',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'DONA AURORA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'GUINOSAYAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'KALIBO (SANTA CRUZ)',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'KAPALUHAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'KATANGTANG',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'KIGTAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'KINALIN IBABA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'KINALIN ILAYA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'KINAMALIGAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'KUMALUDKUD',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'KUNALUM',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'KUYAOYAO',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'LAGAY',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'LAINGLAINGAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'LUNGIB',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'MADLANGDUNGAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'MAGLIPAD (ROSARIO)',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'MAMBALING',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'MANHULUGIN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'MARILAG (PUNAYA)',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'MULAY',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'PANDANAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'PANSOL',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'PATIHAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'PINAGBAYANAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'PINAGKAMALIGAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'PINAGSAKAHAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'PINAGTALLERAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'RIZAL IBABA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'RIZAL ILAYA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SABANG I',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SABANG II',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SAN QUINTIN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SAN ROQUE IBABA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SAN ROQUE ILAYA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SANTA CECILIA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SANTA MILAGROSA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SANTO ANGEL (PANGAHOY)',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SINAG',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SUMILANG',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'SUMULONG',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'TABANSAK',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'TALINGTING',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'TAMIS',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'TIKIWAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'TINIGUIBAN',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'VILLA MAGSINO',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'VILLA SAN ISIDRO',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'VINAS',
    },
    {
        CITY: 'CALAUAG',
        BARANGAY: 'YAGANAK',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'AJOS',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'ANUSAN',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'BULAGSONG',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'CAMANDIISON',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'CANCULAJAO',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'CATUMBO',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'CAWAYANIN IBABA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'CAWAYANIN ILAYA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'CUTCUTAN',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'DAHICAN',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'DOONGAN IBABA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'DOONGAN ILAYA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'GATASAN',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'MACPAC',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'MADULAO',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'MATANDANG SABANG KANLURAN',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'MATANDANG SABANG SILANGAN',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'MILAGROSA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'NAVITAS',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'PACABIT',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'SAN ANTONIO MAGKUPA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'SAN ANTONIO PALA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'SAN JOSE (ANYAO)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'SAN PABLO (SUHA)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'SAN ROQUE (DOYON)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'SAN VICENTE KANLURAN',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'SAN VICENTE SILANGAN',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'SANTA MARIA (DAO)',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'TAGABAS IBABA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'TAGABAS ILAYA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'TAGBACAN IBABA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'TAGBACAN ILAYA',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'TAGBACAN SILANGAN',
    },
    {
        CITY: 'CATANAUAN',
        BARANGAY: 'TUHIAN',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'ANOLING',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'BANGLOS',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'BATANGAN',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'CANAWAY',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'CATABLINGAN',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'LUMUTAN',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'MAGSIKAP',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'MAHABANG LALIM',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'MAIGANG',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'MINAHAN NORTE',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'MINAHAN SUR',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'PAGSANGAHAN',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'PAMPLONA',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'PISA',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'SABLANG',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'SAN MARCELINO',
    },
    {
        CITY: 'GENERAL-NAKAR',
        BARANGAY: 'UMIRAY',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'A. MABINI',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'ALONEROS',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'ARBISMEN',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'BALINARIN',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'BUKAL MALIGAYA',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'CABIBIHAN',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'CABONG NORTE',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'CABONG SUR',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'CALIMPAK',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'CAPULUAN CENTRAL',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'CAPULUAN TULON',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'DANCALAN CAIMAWAN',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'DANCALAN CENTRAL',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'DANLAGAN BATIS',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'DANLAGAN CABAYAO',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'DANLAGAN CENTRAL',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'DANLAGAN RESERVA',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'DUNGAWAN CENTRAL',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'DUNGAWAN PAALYUNAN',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'DUNGAWAN PANTAY',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'ERMITA',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'GAPAS',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'HIMBUBULO ESTE',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'HIMBUBULO WESTE',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'HINABAAN',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'LIGPIT BANTAYAN',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'LUBIGAN',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'MAGALLANES',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'MANGGAGAWA',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'MANGGALANG',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'MANLAYO',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SALAKAN',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SAN LUIS I',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SAN LUIS II',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SAN PEDRO I',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SAN PEDRO II',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SINTONES',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'SISI',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'TIKAY',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'TRIUMPO',
    },
    {
        CITY: 'GUINAYANGAN',
        BARANGAY: 'VILLA HIWASAYAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'ADIA BITAOG',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'ANONANGIN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'BAGONG BUHAY (POB.)',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'BAMBAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'BANTAD',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'BATONG DALIG',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'BINAMBANG',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'BUENSUCESO',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'BUNGAHAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'BUTAGUIN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'CALUMANGIN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'CAMOHAGUIN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'CASASAHAN IBABA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'CASASAHAN ILAYA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'GAYAGAYAAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'GITNANG BARRIO',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'HAGAKHAKIN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'HARDINAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'INACLAGAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'INAGBUHAN ILAYA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'LABNIG',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'LAGUNA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'LAGYO',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'MABINI (POB.)',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'MABUNGA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'MALABTOG',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'MANLAYAAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'MARCELO H. DEL PILAR',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'MATAAS NA BUNDOK',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'MAUNLAD (POB.)',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'PAGSABANGAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'PANIKIHAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'PENAFRANCIA (POB.)',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'PIPISIK (POB.)',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'PROGRESO',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'SAN DIEGO',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'SAN DIEGO POBLACION',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'SAN ISIDRO KANLURAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'SAN ISIDRO SILANGAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'SAN JUAN DE JESUS',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'SASTRE',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'TABING DAGAT (POB.)',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'TUMAYAN',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'VILLA ARCAYA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'VILLA BOTA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'VILLA FUERTE',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'VILLA M. PRINCIPE',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'VILLA MENDOZA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'VILLA NAVA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'VILLA PADUA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'VILLA PEREZ',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'VILLA TANADA',
    },
    {
        CITY: 'GUMACA',
        BARANGAY: 'VILLA VICTORIA',
    },
    {
        CITY: 'JOMALIG',
        BARANGAY: 'APAD',
    },
    {
        CITY: 'JOMALIG',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'JOMALIG',
        BARANGAY: 'CASUGURAN',
    },
    {
        CITY: 'JOMALIG',
        BARANGAY: 'GANGO',
    },
    {
        CITY: 'JOMALIG',
        BARANGAY: 'PAALAMAN',
    },
    {
        CITY: 'JOMALIG',
        BARANGAY: 'TALISOY (POB.)',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BACUNGAN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BANABAHIN IBABA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BANABAHIN ILAYA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BEBITO',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BIGAJO',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BINAHIAN A',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BINAHIAN B',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BINAHIAN C',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BOCBOC',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BURGOS (POB.)',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'BUYACANIN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'CAGACAG',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'CALANTIPAYAN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'CANDA IBABA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'CANDA ILAYA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'CAWAYANIN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'COGORIN IBABA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'COGORIN ILAYA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'DANLAGAN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'DE LA PAZ',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'ESPERANZA IBABA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'ESPERANZA ILAYA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'GOMEZ (POB.)',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'GUIHAY',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'GUINUANGAN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'GUITES',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'HONDAGUA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'ILAYANG ILOG A',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'ILAYANG ILOG B',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'INALUSAN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'JONGO',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'LALAGUNA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MABANBAN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MAGALLANES',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MAGSAYSAY (POB.)',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MAGUILAYAN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MAHAYOD-HAYOD',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MAL-AY',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MANDOOG',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MANGUISIAN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MATINIK',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'MONTECLARO',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'PAMAMPANGIN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'PANSOL',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'PENAFRANCIA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'PISIPIS',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'RIZAL (POBLACION)',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'RIZAL (RURAL)',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'ROMA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAMAT',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAN FRANCISCO A',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAN FRANCISCO B',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAN MIGUEL (DAO)',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SANTA JACOBE',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SANTA TERESA (MAYUPAG)',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SANTO NINO IBABA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SANTO NINO ILAYA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SILANG',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'SUMALANG',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'TALOLONG (POB.)',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'TAN-AG IBABA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'TAN-AG ILAYA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'TOCALIN',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'VEGAFLOR',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'VERGANA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'VERONICA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'VILLA ESPINA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'VILLA GEDA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'VILLA HERMOSA',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'VILLAMONTE',
    },
    {
        CITY: 'LOPEZ',
        BARANGAY: 'VILLANACAOB',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'ABANG',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'ALILIW',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'ATULINAO',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'AYUTI',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'IGANG',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'KABATETE',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'KAKAWIT',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'KALANGAY',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'KALYAAT',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'KILIB',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'KULAPI',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'MAHABANG PARANG',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'MALUPAK',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'MANASA',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'MAY-IT',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'NAGSINAMO',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'NALUNAO',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'PALOLA',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'PIIS',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'SAMIL',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'TIAWE',
    },
    {
        CITY: 'LUCBAN',
        BARANGAY: 'TINAMNAN',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BARRA',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'BOCOHAN',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'COTTA',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'DALAHICAN',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'DOMOIT',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'GULANG-GULANG',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'IBABANG DUPAY',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'IBABANG IYAM',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'IBABANG TALIM',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'ILAYANG DUPAY',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'ILAYANG IYAM',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'ILAYANG TALIM',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'ISABANG',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'MARKET VIEW',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'MAYAO CASTILLO',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'MAYAO CROSSING',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'MAYAO KANLURAN',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'MAYAO PARADA',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'MAYAO SILANGAN',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'RANSOHAN',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'SALINAS',
    },
    {
        CITY: 'LUCENA',
        BARANGAY: 'TALAO-TALAO',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'AMONTAY',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'ANOS',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'BUYAO',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'CALANTAS',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'CANDANGAL',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'CASTILLO (POB.)',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'DAMAYAN (POB.)',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'LAHING',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'LUCTOB',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'MABINI IBABA',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'MABINI ILAYA',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'MALABAHAY',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'MAMBOG',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'MASIPAG (POB.)',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'OLONGTAO IBABA',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'OLONGTAO ILAYA',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'PADRE HERRERA',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'PAG-ASA (POB.)',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'PAJARILLO',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'PINAGBAYANAN',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'RODRIQUEZ (POB.)',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'TAGUIN',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'TUBIGAN IBABA',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'TUBIGAN ILAYA',
    },
    {
        CITY: 'MACALELON',
        BARANGAY: 'VISTA HERMOSA',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'ABO-ABO',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'ALITAP',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'BAAO',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'BAGONG BAYAN (POB.)',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'BALAYBALAY',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'CAGBALETE I',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'CAGBALETE II',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'CAGSIAY I',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'CAGSIAY II',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'CAGSIAY III',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'DAUNGAN (POB.)',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'LIWAYWAY',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'LUAL (POB.)',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'LUAL RURAL',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'LUCUTAN',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'LUYA-LUYA',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'MABATO (POB.)',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'MACASIN',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'REMEDIOS I',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'REMEDIOS II',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'RIZALIANA (POB.)',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SADSARAN (POB.)',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SANTO ANGEL',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'SOLEDAD',
    },
    {
        CITY: 'MAUBAN',
        BARANGAY: 'TAPUCAN',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'AJOS',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'AJOS',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'AMUGUIS',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'BAGUPAYE',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'BUTANYOG',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'CANUYEP',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'F. NANADIEGO',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'IBABANG CAMBUGA',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'IBABANG YUNI',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'ILAYANG CAMBUGA (MABINI)',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'ILAYANG YUNI',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'LATANGAN',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'MATATAJA',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'PAKIING',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'PATABOG',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'SAGONGON',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'MULANAY',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'ALUPAYE',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'ANATO',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'BANTIGUE',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'BARANGAY 1 CASTILLO (POB.)',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'BARANGAY 2 DAUNGAN (POB.)',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'BARANGAY 3 DEL CARMEN (POB.)',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'BARANGAY 4 PARANG (POB.)',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'BARANGAY 5 SANTA CATALINA (POB.)',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'BARANGAY 6 TAMBAK (POB.)',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'BIGO',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'BINAHAAN',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'IBABANG BAGUMBUNGAN',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'IBABANG PALSABANGON',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'IBABANG POLO',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'IKIRIN',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'ILAYANG BAGUMBUNGAN',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'ILAYANG PALSABANGON',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'ILAYANG POLO',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'KANLURAN MALICBOY',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'MAPAGONG',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'MAYHAY',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'PINAGBAYANAN',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'SILANGAN MALICBOY',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'TALIPAN',
    },
    {
        CITY: 'PAGBILAO',
        BARANGAY: 'TUKALAN',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'BALUNGAY',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'CALASUMANGA',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'KINALAGTI',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'LIBO',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'LIPATA',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'MATANGKAP',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'MILAWID',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'PAGITAN',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'PANUKULAN',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'PATNANUNGAN',
        BARANGAY: 'AMAGA',
    },
    {
        CITY: 'PATNANUNGAN',
        BARANGAY: 'BUSDAK',
    },
    {
        CITY: 'PATNANUNGAN',
        BARANGAY: 'KILOGAN',
    },
    {
        CITY: 'PATNANUNGAN',
        BARANGAY: 'LUOD',
    },
    {
        CITY: 'PATNANUNGAN',
        BARANGAY: 'PATNANUNGAN NORTE',
    },
    {
        CITY: 'PATNANUNGAN',
        BARANGAY: 'PATNANUNGAN SUR (POB.)',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'BAGONG PAG-ASA POB. (BARANGAY 3)',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'BAGONG SILANG POB. (BARANGAY 4)',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'MAABOT',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'MAINIT NORTE',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'MAINIT SUR',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'MAPAGMAHAL POB. (BARANGAY 2)',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'PAGKAKAISA POB. (BARANGAY 1)',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'PAMBUHAN',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'PINAGTUBIGAN ESTE',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'PINAGTUBIGAN WESTE',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'SANGIRIN',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'VILLAMANZANO NORTE',
    },
    {
        CITY: 'PEREZ',
        BARANGAY: 'VILLAMANZANO SUR',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'ANAWAN',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'ATULAYAN',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'BALESIN',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'BANADERO',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'BINIBITINAN',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'BISLIAN',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'BUCAO',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'CANICANIAN',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'KALUBAKIS',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'LANGUYIN',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'PAMATDAN',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'PILION',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'PINAGLUBAYAN',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'SALIPSIP',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'SIBULAN',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'TALUONG',
    },
    {
        CITY: 'POLILLO',
        BARANGAY: 'TAMULAYA-ANITONG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BATABAT NORTE',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BATABAT SUR',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BULO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CABONG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CADLIT',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CATULIN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CAWA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'DE LA PAZ',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'HAGONGHONG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'IBABANG WASAY',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'ILAYANG WASAY',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'LILUKIN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MABUTAG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MAGALLANES',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MALIGAYA (ESPERANZA)',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MANLANA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MASAYA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SABANG PINAMASAGAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SABANG PIRIS',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN DIEGO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN ISIDRO IBABA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN ISIDRO ILAYA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN PEDRO (VILLA RODRIGO)',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SIAIN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'VILLA BATABAT',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'VILLA MAGSAYSAY',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'VILLA VERONICA',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'BUENAVISTA EAST',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'BUENAVISTA WEST',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'BUKAL NORTE',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'BUKAL SUR',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'KINATIHAN I',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'KINATIHAN II',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MALABANBAN NORTE',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MALABANBAN SUR',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MANGILAG NORTE',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MANGILAG SUR',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MASALUKOT I',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MASALUKOT II',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MASALUKOT III',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MASALUKOT IV',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MASALUKOT V',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MASIN NORTE',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MASIN SUR',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MAYABOBO',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'PAHINGA NORTE',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'PAHINGA SUR',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'SANTA CATALINA NORTE',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'SANTA CATALINA SUR',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'ANTONINO (AYUSAN)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BAGONG ANYO (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BAYANIHAN (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BULAKIN I',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BULAKIN II',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BUNGOY',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'CABATANG',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'DAGATAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'KINABUHAYAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'MALIGAYA (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'MANGGAHAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'PINAGDANLAYAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'PUTOL',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SILANGANAN (POB.)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BACONG IBABA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BACONG ILAYA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'LAVIDES',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'MALAYA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'NIEVA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'RECTO',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SAN IGNACIO IBABA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SAN IGNACIO ILAYA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SAN ISIDRO IBABA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SAN ISIDRO ILAYA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SANTA MARIA IBABA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SANTA MARIA ILAYA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SUMILANG',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'VILLARICA',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'ABIAWIN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'AGOS-AGOS',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'ALITAS',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'AMOLONGIN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'ANIBONG',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'ANTIKIN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BALOBO',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BANTILAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BANUGAO',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BATICAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BINONOAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BINULASAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BOBOIN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'CATAMBUNGAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'CAWAYNIN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'COMON',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'DINAHICAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'GUMIAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'ILOG',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'INGAS',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'LANGGAS',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'LUAL',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'MAYPULOT',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'MISWA',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'PILAWAY',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'PINAGLAPATAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'POBLACION 1 (BARANGAY 1)',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'POBLACION 38 (POBLACION BARANGAY 2)',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'POBLACION 39 (POBLACION BARANGAY 3)',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'PULO',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'SILANGAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'TONGOHIN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'TUDTURAN',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'BASIAO (POB.)',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'BURGOS (POB.)',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'CABUYAO NORTE',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'CABUYAO SUR',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'CAMPO (POB.)',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'DANLAGAN',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'DUHAT',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'HINGUIWIN',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'KINAGUNAN IBABA',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'KINAGUNAN ILAYA',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'LIPATA',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'MARAO',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'MARQUEZ',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'PUNTA (POB.)',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'SIPA',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'TULAY BUHANGIN',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'VILLAPAZ',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'WALAY',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'YAWE',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'AMONTAY',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'BILUCAO',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'CABULIHAN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'CASTILLO (POB.)',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'CAWAYANIN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'COMETA',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'DALAMPASIGAN (POB.)',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'DULONG BAYAN (POB.)',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'GANGAHIN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'IBABANG BURGOS',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'IBABANG PACATIN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'IBABANG PINA',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'IBABANG SOLIYAO',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'ILAYANG BURGOS',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'ILAYANG PACATIN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'ILAYANG PINA',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'ILAYANG SOLIYAO',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'MAALIW (POB.)',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'MANGGAHAN (POB.)',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'MASAYA (POB.)',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'MAYUBOK (POB.)',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'NAG-CRUZ',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'PAG-ASA (POB.)',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'PAMILIHAN (POB.)',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'PAYTE',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'PINAGBAYANAN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'POCTOL',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'QUINAGASAN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'RIZALINO',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'SAGUINSINAN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'SISIRIN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'SUMAG ESTE',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'SUMAG NORTE',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'SUMAG WESTE',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'DUHAT',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'ILOSONG',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'M. L. TUMAGAY POB. (REMAS MABUTON)',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'PAANG BUNDOK (POB.)',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'PAMPAARALAN (POB.)',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'TANAUAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'APAD',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ARGOSINO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BARANGAY VI (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CAGBALOGO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'COMETA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'GUINHAWA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'GUMUBAT',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MAGSINO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MASCARINA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MONTANA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SILANGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TAGKAWA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'VILLA BELEN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'VILLA FRANCIA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'VILLA GOMEZ',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'VILLA MERCEDES',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'ALUPAY',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'APASAN',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'BANOT',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'BATAAN',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'BAYONGON',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'BILUCAO',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'CALDONG',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'IBABANG OWAIN',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'ILAYANG OWAIN',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'MAMALA',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'SAN BUENO',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'SAMPALOC',
        BARANGAY: 'TAQUICO',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'ALIBIHABAN',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'CAMFLORA',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'MANGERO',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'PANSOY',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'TALA',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'ARAWAN',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'BAGONG NIING',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'BALAT ATIS',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'BRIONES',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'BULIHAN',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'BULIRAN',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'CALLEJON',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'CORAZON',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'LOOB',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'MANUEL DEL VALLE',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'MANUEL DEL VALLE SR.',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'MATIPUNSO',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'NIING',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'PULO',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'PURY',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAMPAGA',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SINTURISAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BUTANGUIAD',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'CASAY',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'CAWAYAN I',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'CAWAYAN II',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'DON JUAN VERCELOS',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'HUYON-UYON',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'IBABANG TAYUMAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'ILAYANG TAYUMAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'INABUAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'MABUNGA',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'NASALAAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'PAGSANGAHAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'PUGON',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SILONGIN',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'ABUYON',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'ANDRES BONIFACIO',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'BANI',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'BAYANIHAN (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'BINAY',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'BUSOKBUSOKAN',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'CALWIT',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'GUINHALINAN',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'LACDAYAN',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'MAGUITING',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'MALIGAYA (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'MANLAMPONG',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'PAGDADAMAYAN (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'PAGKAKAISA (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'VIGO CENTRAL',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'VILLA AURIN (PINAGSAMA)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'VILLA REYES',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'WHITE CLIFF',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'CAPALONG',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'KILOLORAN',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'LLAVAC',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'LUBAYAT',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'MALAPAD',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'MARAGONDON',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'MASIKAP',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'MAUNLAD',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'POBLACION 61 (BARANGAY 2)',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'POBLACION I (BARANGAY 1)',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'TANAUAN',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'TIGNOAN',
    },
    {
        CITY: 'REAL',
        BARANGAY: 'UNGOS',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'BALUBAL',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'BIGNAY 1',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'BIGNAY 2',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'BUCAL',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'CANDA',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'CASTANAS',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'CONCEPCION BANAHAW',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'CONCEPCION NO. 1',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'CONCEPCION PALASAN',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'CONCEPCION PINAGBAKURAN',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'GIBANGA',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'GUISGUIS-SAN ROQUE',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'GUISGUIS-TALON',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'JANAGDONG 1',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'JANAGDONG 2',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'LIMBON',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'LUTUCAN 1',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'LUTUCAN BATA',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'LUTUCAN MALABAG',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'MAMALA I',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'MAMALA II',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'MANGGALANG 1',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'MANGGALANG TULO-TULO',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'MANGGALANG-BANTILAN',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'MANGGALANG-KILING',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'MONTECILLO',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'MORONG',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'SAMPALOC 1',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'SAMPALOC 2',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'SAMPALOC BOGON',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'SAMPALOC SANTO CRISTO',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'TALAAN APLAYA',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'TALAANPANTOC',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'TUMBAGA 1',
    },
    {
        CITY: 'SARIAYA',
        BARANGAY: 'TUMBAGA 2',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'ALDAVOC',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'ALIJI',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'BAMBAN',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'BOSIGON',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'CABIBIHAN',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'CABUGWANG',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'CAGASCAS',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'CANDALAPDAP',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'CASISPALAN',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'COLONG-COLONG',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'KATIMO',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'KINATAKUTAN',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'LANDING',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'LAUREL',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'MAGUIBUAY',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'MAHINTA',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'MALBOG',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'MANATO CENTRAL',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'MANATO STATION',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'MANGAYAO',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'MANSILAY',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'MAPULOT',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'MUNTING PARANG',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'PAYAPA',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SAN DIEGO',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SANTA CECILIA',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SANTO NINO I',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SANTO NINO II',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'SEGUIWAN',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'TABASON',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'TUNTON',
    },
    {
        CITY: 'TAGKAWAYAN',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ALITAO',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ALSAM IBABA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ALSAM ILAYA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ALUPAY',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ANGELES ZONE I (POB.)',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ANGELES ZONE II',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ANGELES ZONE III',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ANGELES ZONE IV',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ANGUSTIAS ZONE I (POB.)',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ANGUSTIAS ZONE II',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ANGUSTIAS ZONE III',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ANGUSTIAS ZONE IV',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ANOS',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'AYAAS',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'BAGUIO',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'BANILAD',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'BUKAL IBABA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'BUKAL ILAYA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'CALANTAS',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'CAMAYSA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'DOMOIT KANLURAN',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'DOMOIT SILANGAN',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'GIBANGA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'IBAS',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ILASAN IBABA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ILASAN ILAYA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'IPILAN',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'ISABANG',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'KATIGAN KANLURAN',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'KATIGAN SILANGAN',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'LAKAWAN',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'LALO',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'LAWIGUE',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'LITA (POB.)',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'MALAOA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'MASIN',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'MATE',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'MATEUNA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'MAYOWE',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'NANGKA IBABA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'NANGKA ILAYA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'OPIAS',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'PALALE IBABA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'PALALE ILAYA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'PALALE KANLURAN',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'PALALE SILANGAN',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'PANDAKAKI',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'POOK',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'POTOL',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'SAN DIEGO ZONE I (POB.)',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'SAN DIEGO ZONE II',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'SAN DIEGO ZONE III',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'SAN DIEGO ZONE IV',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'SAN ISIDRO ZONE I (POB.)',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'SAN ISIDRO ZONE II',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'SAN ISIDRO ZONE III',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'SAN ISIDRO ZONE IV',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'SAN ROQUE ZONE I (POB.)',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'SAN ROQUE ZONE II',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'TALOLONG',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'TAMLONG',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'TONGKO',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'VALENCIA',
    },
    {
        CITY: 'TAYABAS',
        BARANGAY: 'WAKAS',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'ANASTACIA (TAGBAK)',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'AQUINO',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'AYUSAN I',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'AYUSAN II',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'BEHIA',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'BULA',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'BULAKIN',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'CABATANG',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'CABAY',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'LAGALAG',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'LALIG',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'LUMINGON',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'LUSACAN',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'PAIISA',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'PALAGARAN',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'QUIPOT',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'TAGBAKIN',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'TIAONG',
        BARANGAY: 'TAMISIAN',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'ALMACEN',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'BALAGTAS',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'BALANACAN',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'BULO IBABA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'BULO ILAYA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'CABULIHAN IBABA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'CABULIHAN ILAYA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'CAIGDAL',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'F. DE JESUS (POB.)',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'KALILAYAN IBABA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'KALILAYAN ILAYA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'MAIROK IBABA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'MAIROK ILAYA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'MALVAR',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'MAPUTAT',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'MULIGUIN',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'PAGAGUASAN',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'PANAON IBABA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'PANAON ILAYA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'POCTOL',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'R. LAPU-LAPU (POB.)',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'R. MAGSAYSAY (POB.)',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'RAJA SOLIMAN (POB.)',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'RIZAL IBABA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'RIZAL ILAYA',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'SOCORRO',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'TUBAS',
    },
    {
        CITY: 'UNISAN',
        BARANGAY: 'TUBIGAN',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'ADIA',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'BALANGON',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'BANGIN',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'BANYAGA',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'BARIGON',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'BILIBINWANG',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'CORAL NA MUNTI',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'GUITNA',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'PAMIGA',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'PANHULAN',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'PANSIPIT',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'POOK',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'SAN JACINTO',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'SAN TEODORO',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'SUBIC IBABA',
    },
    {
        CITY: 'AGONCILLO',
        BARANGAY: 'SUBIC ILAYA',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'BALAGBAG',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'CONCORDIA',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'DALIPIT EAST',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'DALIPIT WEST',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'DOMINADOR EAST',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'DOMINADOR WEST',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'MUNLAWIN NORTE',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'MUNLAWIN SUR',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'MUZON PRIMERO',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'MUZON SEGUNDO',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'PINAGKURUSAN',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'PING-AS',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ALITAGTAG',
        BARANGAY: 'TADLAC',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BACLARAN',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'CALAN',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'CALOOCAN',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'CALZADA',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'CANDA',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'CARENAHAN',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'CAYBUNGA',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'CAYPONCE',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'DALIG',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'DILAO',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'DUHATAN',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'DURUNGAO',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'GIMALAS',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'GUMAMELA',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'LAGNAS',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'LANATAN',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'LANGGANGAN',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'LUCBAN POOK',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'LUCBAN PUTOL',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'MAGABE',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'MALALAY',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'MUNTING TUBIG',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'NAVOTAS',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'PALIKPIKAN',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'PATUGO',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'POOC',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'SAMBAT',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'SAMPAGA',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'SAN PIRO',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'SUKOL',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'TACTAC',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'TALUDTUD',
    },
    {
        CITY: 'BALAYAN',
        BARANGAY: 'TANGGOY',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'ALANGILAN',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'CALAWIT',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'MAGAPI',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'MAKINA',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'MALABANAN',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'PALIGAWAN',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'PALSARA',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'SALA',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'SAMPALOCAN',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'SOLIS',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'ALANGILAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BALAGTAS',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BALETE',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BANABA CENTER',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BANABA IBABA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BANABA KANLURAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BANABA SILANGAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 13 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 14 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 15 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 16 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 17 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 18 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 19 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 20 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 21 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 22 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 23 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 24 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BILOGO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BOLBOK',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'CALICANTO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'CATANDALA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'CONDE ITAAS',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'CONDE LABAK',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'CUTA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'DALIG',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'DELA PAZ',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'DELA PAZ PULOT APLAYA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'DELA PAZ PULOT ITAAS',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'DOMOCLAY',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'DUMANTAY',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'GULOD ITAAS',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'GULOD LABAK',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'HALIGUE KANLURAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'HALIGUE SILANGAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'KUMBA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'KUMINTANG IBABA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'KUMINTANG ILAYA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'LIPONPON',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'LIPONPON ISLA VERDE',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'MAAPAS',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'MABACONG (MATOCO)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'MAHABANG DAHILIG',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'MAHABANG PARANG',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'MAHACOT KANLURAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'MAHACOT SILANGAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'MALALIM',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'MALIBAYO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'MALITAM',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'MARUCLAP',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'PAGKILATAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'PAHARANG KANLURAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'PAHARANG SILANGAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'PALLOCAN KANLURAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'PALLOCAN SILANGAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'PINAMUCAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'PINAMUCAN IBABA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'PINAMUCAN SILANGAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAMPAGA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN AGAPITO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN AGAPITO ISLA VERDE',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN AGUSTIN KANLURAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN AGUSTIN KANLURAN ISLA VERDE',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN AGUSTIN SILANGAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN AGUSTIN SILANGAN ISLA VERDE',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN ANDRES ISLA VERDE',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN ANTONIO ISLA VERDE',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN JOSE SICO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SANTA RITA APLAYA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SANTA RITA KARSADA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SIMLONG',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SIRANG LUPA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SOROSORO IBABA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SOROSORO ILAYA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'SOROSORO KARSADA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'TABANGAO AMBULONG',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'TABANGAO APLAYA (TABANGAO PROPER)',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'TABANGAO DAO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'TALAHIB PANDAYAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'TALAHIB PAYAPA',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'TALUMPOK KANLURAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'TALUMPOK SILANGAN',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'TINGA ITAAS',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'TINGA LABAK',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'TULO',
    },
    {
        CITY: 'BATANGAS',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'ANAK-DAGAT',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'ARUMAHAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'AYAO-IYAO',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'BAGONG POOK',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'BALANGA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'CAHILAN I',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'CAHILAN II',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'DAYAPAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'DISTRICT III (POB.)',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'DISTRICT IV (POB.)',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'DITA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'GULOD',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'LUCKY',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MAGUIHAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MAHABANG DAHILIG',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MAIGSING DAHILIG',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MALINIS',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MASALISI',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MATAAS NA BAYAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MATINGAIN I',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MATINGAIN II',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MAYASANG',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'NIUGAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'NONONG CASTO',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'PAYAPA IBABA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'PAYAPA ILAYA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SAMBAL IBABA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SAMBAL ILAYA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SAN ISIDRO IBABA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SAN ISIDRO ITAAS',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SANGALANG',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SINISIAN EAST',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SINISIAN WEST',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'TALAGA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'TUBIGAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'TUBUAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'WAWA IBABA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'WAWA ILAYA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'ANILAO EAST',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'ANILAO PROPER',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'BAGALANGIT',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'BULACAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CALAMIAS',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'GASANG',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'LAUREL',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'MAINAGA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'MAJUBEN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'MALIMATOC I',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'MALIMATOC II',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'NAG-IBA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'PILAHAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'PULANG LUPA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'PULONG ANAHAO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'PULONG BALIBAGUHAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'PULONG NIOGAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAGUING',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAN TEODORO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SANTA MESA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SOLO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'TALAGA EAST',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'TALAGA PROPER',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'ALUPAY',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BAGONG POOK',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BALIBAGO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BARANGAY A (POB.)',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BARANGAY B (POB.)',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BARANGAY C (POB.)',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BARANGAY D (POB.)',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BARANGAY E (POB.)',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BAYAWANG',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BAYBAYIN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BULIHAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CAHIGAM',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CALANTAS',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'COLONGAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'ITLUGAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'LEVISTE (TUBAHAN)',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'LUMBANGAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MAALAS-AS',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MABATO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MABUNGA',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MACALAMCAM A',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MACALAMCAM B',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MALAYA',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MARILAG',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MASAYA',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MATAMIS',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MAVALOR',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MAYURO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'NAMUCO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'NAMUNGA',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'NASI',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'NATU',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'PALAKPAK',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'PINAGSIBAAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'PUTINGKAHOY',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'QUILIB',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SALAO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAN IGNACIO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'TIMBUGAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'TIQUIWAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'TULOS',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'AGUILA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'ANUS',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'AYA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BAGONG POOK',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BALAGTASIN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BALAGTASIN I',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BANAYBANAY I',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BANAYBANAY II',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BIGAIN I',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BIGAIN II',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BIGAIN SOUTH',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CALANSAYAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'DAGATAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'DON LUIS',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'GALAMAY-AMO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LALAYAT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LAPOLAPO I',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LAPOLAPO II',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LEPUTE',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LUMIL',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MOJON-TAMPOY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'NATUNUAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PALANCA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PINAGTUNG-ULAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'POBLACION BARANGAY I',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'POBLACION BARANGAY II',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'POBLACION BARANGAY III',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'POBLACION BARANGAY IV',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SALABAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TAYSAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TUGTUG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'ABUNG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BALAGBAG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BARUALTE',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BATAAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BUHAY NA SAPA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BULSA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CALICANTO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CALITCALIT',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CALUBCUB I',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CALUBCUB II',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'COLOCONTO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'ESCRIBANO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'HUGOM',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'IMELDA (TUBOG)',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'JANAOJANAO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'LAIYA-APLAYA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'LAIYA-IBABAO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'LIBATO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'LIPAHAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'MABALANOY',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'MARAYKIT',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'MUZON',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'NAGSAULAY',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PALAHANAN I',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PALAHANAN II',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PALINGOWAK',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PINAGBAYANAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'POCTOL',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PULANGBATO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PUTINGBUHANGIN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'QUIPOT',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SAMPIRO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SAPANGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SICO I',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SICO II',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SUBUKIN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TALAHIBAN I',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TALAHIBAN II',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TICALAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TIPAZ',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'ABIACAO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'BAGONG TUBIG',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'BALAGTASIN',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'BANOYO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'BOBOY',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'BONLIW',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'CALUMPANG EAST',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'CALUMPANG WEST',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'DULANGAN',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'DURUNGAO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'LOCLOC',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'LUYA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'MAHABANG PARANG',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'MANGGAHAN',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'MUZON',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN MARTIN',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'TALIBA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'TALON',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'TEJERO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'TUNGAL',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'ABELO',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'ALAS-AS',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'BALETE',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'BALUK-BALUK',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'BANCORO',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'BANGIN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'CALANGAY',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'HIPIT',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'MAABUD NORTH',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'MAABUD SOUTH',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'MUNLAWIN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'PANSIPIT',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'PULANG-BATO',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SINTURISAN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'TAGUDTOD',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'TALANG',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'ALALUM',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'BALIMBING',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'BANABA',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'BAYANAN',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'DANGLAYAN',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'GELERANG KAWAYAN',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'ILAT NORTH',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'ILAT SOUTH',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'KAINGIN',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'LAUREL',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'MALAKING POOK',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'MATAAS NA LUPA',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'NATUNUAN NORTH',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'NATUNUAN SOUTH',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'PADRE CASTILLO',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'PALSAHINGIN',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'PILA',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'POOK NI BANAL',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'POOK NI KAPITAN',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'RESPLANDOR',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'SAMBAT',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'SAN MARIANO',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'SAN-PASCUAL',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'BIHIS',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'BUROL',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'CALAYAAN',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'CALUMALA',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'CUTA EAST',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'CUTANG CAWAYAN',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'IRUKAN',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'PACIFICO',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'SAIMSIM',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'SAMPA',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'SINIPIAN',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'TAMBO IBABA',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'TAMBO ILAYA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN BARTOLOME',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN FELIX',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN ISIDRO NORTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN ISIDRO SUR',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTA ANASTACIA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'AYA',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'BALAS',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'BANGA',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'BUCO',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'CALOOCAN',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'LEYNES',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'MIRANDA',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POBLACION BARANGAY 1',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POBLACION BARANGAY 2',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POBLACION BARANGAY 3',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POBLACION BARANGAY 4',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POBLACION BARANGAY 5',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POBLACION BARANGAY 6',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POBLACION BARANGAY 7',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POBLACION BARANGAY 8',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'QUILING',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SAN GUILLERMO',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'TRANCA',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'TUMAWAY',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'ALAGAO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'APLAYA',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'AS-IS',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'BAGUILAWA',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'BALAYONG',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'COLVO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'CUPANG',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'DURUNGAO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'GULIBAY',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'INICBULAN',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'LOCLOC',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'MAGALANG-GALANG',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'MALINDIG',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'MANALUPONG',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'MANGHINAO PROPER',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'MANGHINAO UNO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'NEW DANGLAYAN',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'ORENSE',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'PITUGO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAN ANDRES PROPER',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAN ANDRES UNO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAN DIEGO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAN TEODORO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'BAUAN',
        BARANGAY: 'SINALA',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BACLAS',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BAGONG TUBIG',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BALIMBING',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BAMBANG',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'BISAYA',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'CAHIL',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'CALANTAS',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'CALUANGAN',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'CAMASTILISAN',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'CORAL NI BACAL',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'CORAL NI LOPEZ (SUGOD)',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'DACANLAO',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'DILA',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'LOMA',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'LUMBANG CALZADA',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'LUMBANG NA BATA',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'LUMBANG NA MATANDA',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'MADALUNOT',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'MAKINA',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'MATIPOK',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'MUNTING CORAL',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'NIYUGAN',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'PANTAY',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'PUTING BATO EAST',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'PUTING BATO WEST',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'PUTING KAHOY',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'QUISUMBING',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'SALONG',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'SINISIAN',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'TAKLANG ANAK',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'TAMAYO',
    },
    {
        CITY: 'CALACA',
        BARANGAY: 'TIMBAIN',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'BAHA',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'BALIBAGO',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'BALITOC',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'BUCAL',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'CARLOSA',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'CARRETUNAN',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'ENCARNACION',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'GULOD',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'HUKAY',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'LUCSUHIN',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'LUYA',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'QUILITISAN',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'REAL',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'SAMBUNGAN',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'TALIBAYOG',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'CALATAGAN',
        BARANGAY: 'TANAGAN',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'BALAGBAG',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'BUNGAHAN',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'CALUMAYIN',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'DALIPIT EAST',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'DALIPIT WEST',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'DITA',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'DON JUAN',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'EMMANUEL',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'IBABAO',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'LABAC',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'PINAGKAISAHAN',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'CUENCA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'BAGO',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'BALANGA',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'BUNGAHAN',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'CALAMIAS',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'CATANDALA',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'COLIAT',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'DAYAPAN',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'LAPU-LAPU',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'LUCSUHIN',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'MABALOR',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'MALAININ',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'MATALA',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'MUNTING-TUBIG',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'PALINDAN',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'PANGAO',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'PANGHAYAAN',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'QUILO',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'SALABAN I',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'SALABAN II',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'SANDALAN',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'TALAIBON',
    },
    {
        CITY: 'IBAAN',
        BARANGAY: 'TULAY NA PATPAT',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'AS-IS',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'BALAKILONG',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'BERINAYAN',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'BUGAAN EAST',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'BUGAAN WEST',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'BUSO-BUSO',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'DAYAP ITAAS',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'GULOD',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'J. LEVISTE',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'MOLINETE',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'NIYUGAN',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'PALIPARAN',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'LAUREL',
        BARANGAY: 'TICUB',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'BAGONG POOK',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'BALIBAGO',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'BINUBUSAN',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'BUNGAHAN',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'CUMBA',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'HUMAYINGAN',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'KAPITO',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'LUMANIAG',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'LUYAHAN',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'MALARUHATAN',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'MATABUNGKAY',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'PRENZA',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'PUTING-KAHOY',
    },
    {
        CITY: 'LIAN',
        BARANGAY: 'SAN DIEGO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'ADYA',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'ANILAO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'ANILAO-LABAC',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'ANTIPOLO DEL NORTE',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'ANTIPOLO DEL SUR',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'BAGONG POOK',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'BALINTAWAK',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'BANAYBANAY',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'BOLBOK',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'BUGTONG NA PULO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'BULACNIN',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'BULAKLAKAN',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'CALAMIAS',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'CUMBA',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'DAGATAN',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'DUHATAN',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'HALANG',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'INOSLOBAN',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'KAYUMANGGI',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'LATAG',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'LODLOD',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'LUMBANG',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'MALAGONLONG',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'MALITLIT',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'MARAUOY',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'MATAAS NA LUPA',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'MUNTING PULO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'PAGOLINGIN BATA',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'PAGOLINGIN EAST',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'PAGOLINGIN WEST',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'PANGAO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'PINAGKAWITAN',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'PINAGTONGULAN',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 1',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 10',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 11',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 2',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 3',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 4',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 5',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 6',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 7',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 8',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 9',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'POBLACION BARANGAY 9-A',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'PUSIL',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAN BENITO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAN CELESTINO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAN GUILLERMO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAN LUCAS',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAN SALVADOR',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAN SEBASTIAN (BALAGBAG)',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SANTO TORIBIO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SAPAC',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'SICO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'TANGOB',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'TANGUAY',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'TIBIG',
    },
    {
        CITY: 'LIPA',
        BARANGAY: 'TIPACAN',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'APAR',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'BALATBAT',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'BALIBAGO',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'BANALO',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'BIGNAY',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'CALO',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'CALUMPIT',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'JAYBANGA',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'LAGADLARIN',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'MABILOG NA BUNDOK',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'MALABRIGO',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'MALALIM NA SANOG',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'MALAPAD NA PARANG',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'MASAGUITSIT',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'NAGTALONGTONG',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'NAGTOCTOC',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'OLO-OLO',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'PINAGHAWANAN',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'SOLOC',
    },
    {
        CITY: 'LOBO',
        BARANGAY: 'TAYUMAN',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'BAGONG POOK',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'BILUCAO (SAN ISIDRO WESTERN)',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'BULIHAN',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'LUTA DEL NORTE',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'LUTA DEL SUR',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'SAN ISIDRO EAST',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'SAN PEDRO I (EASTERN)',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'SAN PEDRO II (WESTERN)',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'SAN PIOQUINTO',
    },
    {
        CITY: 'MALVAR',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'BARANGAY II-A (POB.)',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'BAYORBOR',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'BUBUYAN',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'CALINGATAN',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'DISTRICT III (POB.)',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'DISTRICT IV (POB.)',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'KINALAGLAGAN',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'LOOB',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'LUMANG LIPA',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'MANGGAHAN',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'NANGKAAN',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'MATAASNAKAHOY',
        BARANGAY: 'UPA',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'AGA',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BALAYTIGUI',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BANILAD',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BILARAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BUCANA',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BULIHAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BUNDUCAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'BUTUCAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'CALAYO',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'CATANDAAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'COGUNAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'DAYAP',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'KAYLAWAY',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'KAYRILAW',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'LATAG',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'LUMBANGAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'MALAPAD NA BATO',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'MATAAS NA PULO',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'MAUGAT',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'MUNTING INDAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'NATIPUAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'PANTALAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'PAPAYA',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'PUTAT',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'REPARO',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'TALANGAN',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'TUMALIM',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'UTOD',
    },
    {
        CITY: 'NASUGBU',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'BANABA',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'BANAYBANAY',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'BAWI',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'CASTILLO',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'CAWONGAN',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'MANGGAS',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'MAUGAT EAST',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'MAUGAT WEST',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'PANSOL',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'PAYAPA',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'QUILO-QUILO NORTH',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'QUILO-QUILO SOUTH',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'TAMAK',
    },
    {
        CITY: 'PADRE-GARCIA',
        BARANGAY: 'TANGOB',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'APACAY',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'BALISONG',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'BIHIS',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'BOLBOK',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'BULI',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'BUTONG',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'CARASUCHE',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'CAWIT',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'CAYSASAY',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'CUBAMBA',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'CULTIHAN',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'GAHOL',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'HALANG',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'IBA',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'ILOG',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'IMAMAWO',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'LAGUILE',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'LATAG',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'LUNTAL',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'MAHABANG LODLOD',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'NIOGAN',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'PANSOL',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 10',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 11',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 12',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 13',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 14',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 4',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 5',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 6',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 7',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 8',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POBLACION 9',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'POOK',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'SEIRAN',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'TATLONG MARIA',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'TIERRA ALTA',
    },
    {
        CITY: 'TAAL',
        BARANGAY: 'TULO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'ALTURA BATA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'ALTURA MATANDA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'ALTURA-SOUTH',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'AMBULONG',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BAGBAG',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BALELE',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BANADERO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BANJO EAST',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BANJO LAUREL (BANJO WEST)',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BILOG-BILOG',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BOOT',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CALE',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'DARASA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'GONZALES',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'HIDALGO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'JANOPOL',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'JANOPOL ORIENTAL',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'LAUREL',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'LUYOS',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'MALAKING PULO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'MARIA PAZ',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'MAUGAT',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'MONTANA (IK-IK)',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'NATATAS',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'PAGASPAS',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'PANTAY BATA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'PANTAY MATANDA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'POBLACION BARANGAY 1',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'POBLACION BARANGAY 2',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'POBLACION BARANGAY 3',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'POBLACION BARANGAY 4',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'POBLACION BARANGAY 5',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'POBLACION BARANGAY 6',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'POBLACION BARANGAY 7',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SALA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SAMBAT',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SANTOL (DONA JACOBA GARCIA)',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SULPOC',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SUPLANG',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'TALAGA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'TINURIK',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'TRAPICHE',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'ULANGO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'BACAO',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'BILOGO',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'DAGATAN',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'GUINHAWA',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'LAUREL',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'MABAYABAS',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'MAHANADIONG',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'MAPULO',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'MATAAS NA LUPA',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'PANGHAYAAN',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'PINA',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'PINAGBAYANAN',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'SAN MARCELINO',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TAYSAN',
        BARANGAY: 'TILAMBO',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'BARANGAY 13 (POBLACION 1)',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'BARANGAY 14 (POBLACION 2)',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'BARANGAY 15 (POBLACION 3)',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'CORONA',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'GAMAO',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'MAKAWAYAN',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'MARIKABAN',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'PAPAYA',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'PISA',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'TINGLOY',
        BARANGAY: 'TALAHIB',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'ACLE',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'BAYUDBUD',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'BOLBOC',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'BURGOS (POB.)',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'DALIMA',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'GUINHAWA',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'LUMBANGAN',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'LUNA (POB.)',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'LUNTAL',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'MAGAHIS',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'MALIBU',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'MATAYWANAC',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'PALINCARO',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'PUTOL',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'RILLO (POB.)',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'TALON',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'TOONG',
    },
    {
        CITY: 'TUY',
        BARANGAY: 'TUYON-TUYON',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'AMUYONG',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'BARANGAY LI (POB.)',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'BILOG',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'BUCK ESTATE',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'ESPERANZA IBABA',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'ESPERANZA ILAYA',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'KAYSUYO',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'KAYTITINGA I',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'KAYTITINGA II',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'KAYTITINGA III',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'LUKSUHIN',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'LUKSUHIN ILAYA',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'MANGAS I',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'MANGAS II',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'MARAHAN I',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'MARAHAN II',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'MATAGBAK I',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'MATAGBAK II',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'PALUMLUM',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'SANTA TERESA',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'SIKAT',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'SINALIW MALAKI',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'SINALIW NA MUNTI',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'SULSUGIN',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'TAYWANAK IBABA',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'TAYWANAK ILAYA',
    },
    {
        CITY: 'ALFONSO',
        BARANGAY: 'UPLI',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BANAYBANAY',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY I',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY II',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY III',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY IV',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY IX',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY IX (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY V',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY VI',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY VI (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY VII',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY VII (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY VIII',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY VIII (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY X',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY X (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY XI',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY XI (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY XII',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BARANGAY XII (POB.)',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BUCAL',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'BUHO',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'DAGATAN',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'HALANG',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'LOMA',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'MAITIM I',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'MAYMANGGA',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'MINANTOK KANLURAN',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'MINANTOK SILANGAN',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'PANGIL',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'SALABAN',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'TALON',
    },
    {
        CITY: 'AMADEO',
        BARANGAY: 'TAMACAN',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ALIMA',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ANIBAN I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ANIBAN II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ANIBAN III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ANIBAN IV',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ANIBAN V',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'BANALO',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'BAYANAN',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'CAMPO SANTO',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'DAANG BUKID',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'DIGMAN',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'DULONG BAYAN',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'HABAY I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'HABAY II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'KAINGIN (POB.)',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'LIGAS I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'LIGAS II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'LIGAS III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MABOLO I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MABOLO II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MABOLO III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MALIKSI I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MALIKSI II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MALIKSI III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MAMBOG I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MAMBOG II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MAMBOG III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MAMBOG IV',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MAMBOG V',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MOLINO I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MOLINO II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MOLINO III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MOLINO IV',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MOLINO V',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MOLINO VI',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'MOLINO VII',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'NIOG I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'NIOG II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'NIOG III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'P.F. ESPIRITU I (PANAPAAN)',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'P.F. ESPIRITU II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'P.F. ESPIRITU III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'P.F. ESPIRITU IV',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'P.F. ESPIRITU V',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'P.F. ESPIRITU VI',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'P.F. ESPIRITU VII',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'P.F. ESPIRITU VIII',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'QUEENS ROW CENTRAL',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'QUEENS ROW EAST',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'QUEENS ROW WEST',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'REAL I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'REAL II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'SALINAS I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'SALINAS II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'SALINAS III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'SALINAS IV',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'SAN NICOLAS I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'SAN NICOLAS II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'SAN NICOLAS III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'SINEGUELASAN',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'TABING DAGAT',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'TALABA I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'TALABA II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'TALABA III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'TALABA IV',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'TALABA V',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'TALABA VI',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'TALABA VII',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ZAPOTE I',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ZAPOTE II',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ZAPOTE III',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ZAPOTE IV',
    },
    {
        CITY: 'BACOOR',
        BARANGAY: 'ZAPOTE V',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'BANCAL',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'CABILANG BAYBAY',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'LANTIC',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'MADUYA',
    },
    {
        CITY: 'CARMONA',
        BARANGAY: 'MILAGROSA',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 1 (HEN. M. ALVAREZ)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 10 (KINGFISHER)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 10-A (KINGFISHER-A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 10-B (KINGFISHER-B)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 11 (LAWIN)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 12 (LOVE BIRD)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 13 (AGUILA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 14 (LORO)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 15 (KILYAWAN)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 16 (MARTINES)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 17 (KALAPATI)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 18 (MAYA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 19 (GEMINI)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 2 (C. TIRONA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 20 (VIRGO)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 21 (SCORPIO)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 22 (LEO)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 22-A (LEO A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 23 (AQUARIUS)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 24 (LIBRA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 25 (CAPRICORN)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 26 (CANCER)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 27 (SAGITARIUS)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 28 (TAURUS)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 29 (LAO-LAO)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 29-A (LAO-LAO A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 3 (HEN. E. AGUINALDO)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 30 (BID-BID)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 31 (MAYA-MAYA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 32 (SALAY-SALAY)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 33 (BUWAN-BUWAN)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 34 (LAPU-LAPU)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 35 (HASA-HASA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 36 (SAP-SAP)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 36-A (SAP-SAP A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 37 (CADENA DE AMOR)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 37-A (CADENA DE AMOR A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 38 (SAMPAGUITA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 38-A (SAMPAGUITA A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 39 (JASMIN)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 4 (HEN. M. TRIAS)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 40 (GUMAMELA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 41 (ROSAL)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 42 (PINAGBUKLOD)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 42-A (PINAGBUKLOD A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 42-B (PINAGBUKLOD B)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 42-C (PINAGBUKLOD C)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 43 (PINAGPALA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 44 (MALIGAYA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 45 (KAUNLARAN)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 45-A (KAUNLARAN A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 46 (SINAGTALA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 47 (PAGKAKAISA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 47-A (PAGKAKAISA A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 47-B (PAGKAKAISA B)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 48 (NARRA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 48-A (NARRA A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 49 (AKASYA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 49-A (AKASYA A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 5',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 5 (HEN. E. EVANGELISTA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 50 (KABALYERO)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 51 (KAMAGONG)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 52 (IPIL)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 53 (YAKAL)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 53-A (YAKAL A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 53-B (YAKAL B)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 54 (PECHAY)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 54-A (PECHAY A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 55 (AMPALAYA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 56 (LABANOS)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 57 (REPOLYO)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 58 (PATOLA)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 58-A (PATOLA A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 59 (SITAW)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 6 (DIEGO SILANG)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 60 (LETSUGAS)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 61 (TALONG)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 61-A (TALONG A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 62 (KANGKONG)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 62-A (KANGKONG A)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 62-B (KANGKONG B)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 7 (KAPITAN KONG)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 8 (MANUEL S. ROJAS)',
    },
    {
        CITY: 'CAVITE',
        BARANGAY: 'BARANGAY 9 (KANAWAY)',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BALIWAG',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BENDITA I',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BENDITA II',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'CALUANGAN',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'KABULUSAN',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'MEDINA',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'PACHECO',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'RAMIREZ',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'TUA',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'URDANETA',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BAGBAG I',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BAGBAG II',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'KANLURAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'LIGTONG I',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'LIGTONG II',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'LIGTONG III',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'LIGTONG IV',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MUZON I',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MUZON II',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAPA I',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAPA II',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAPA III',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAPA IV',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SILANGAN I',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SILANGAN II',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'TEJEROS CONVENTION',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'WAWA I',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'WAWA II',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'WAWA III',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'BUROL',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'BUROL I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'BUROL II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'BUROL III',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'EMMANUEL BERGADO I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'EMMANUEL BERGADO II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'FATIMA I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'FATIMA II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'FATIMA III',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'H-2',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'LANGKAAN I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'LANGKAAN II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'LUZVIMINDA I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'LUZVIMINDA II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'PALIPARAN I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'PALIPARAN II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'PALIPARAN III',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAINT PETER I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAINT PETER II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SALAWAG',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SALITRAN I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SALITRAN II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SALITRAN III',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SALITRAN IV',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAMPALOC I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAMPALOC II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAMPALOC III',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAMPALOC IV',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAMPALOC V',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN AGUSTIN I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN AGUSTIN II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN AGUSTIN III',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN ANDRES I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN ANDRES II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN ANTONIO DE PADUA I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN ANTONIO DE PADUA II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN DIONISIO (BARANGAY 1)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN ESTEBAN (BARANGAY 4)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN FRANCISCO I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN FRANCISCO II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN ISIDRO LABRADOR I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN ISIDRO LABRADOR II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN JUAN (SAN JUAN I)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN LORENZO RUIZ I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN LORENZO RUIZ II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN LUIS I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN LUIS II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN MANUEL I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN MANUEL II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN MIGUEL II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN NICOLAS I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN NICOLAS II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN ROQUE (STA. CRISTINA II)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SAN SIMON (BARANGAY 7)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SANTA CRISTINA I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SANTA CRISTINA II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SANTA CRUZ I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SANTA CRUZ II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SANTA LUCIA (SAN JUAN II)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SANTA MARIA (BARANGAY 20)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SANTO CRISTO (BARANGAY 3)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SANTO NINO I',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'SANTO NINO II',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'VICTORIA REYES',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'ZONE I-B',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'DASMARINAS',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'ALDIANO OLAES',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'BARANGAY 1 POBLACION (AREA I)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'BARANGAY 2 POBLACION',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'BARANGAY 3 POBLACION',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'BARANGAY 4 POBLACION',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'BARANGAY 5 POBLACION',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'BENJAMIN TIRONA (AREA D)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'BERNARDO PULIDO (AREA H)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'EPIFANIO MALIA',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'FIORELLO CALIMAG (AREA C)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'FIORELLO CARIMAG (AREA C)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'FRANCISCO DE CASTRO (SUNSHINE VILL.)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'FRANCISCO REYES',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'GAVINO MADERAN',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'GREGORIA DE JESUS',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'INOCENCIO SALUD',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'JACINTO LUMBRERAS',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'KAPITAN KUA (AREA F)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'KORONEL JOSE P. ELISES (AREA E)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'MACARIO DACON',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'MARCELINO MEMIJE',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'NICOLASA VIRATA (SAN JOSE)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'PANTALEON GRANADOS (AREA G)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'RAMON CRUZ (AREA J)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'SAN GABRIEL (AREA K)',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'SEVERINO DE LAS ALAS',
    },
    {
        CITY: 'GEN.-MARIANO-ALVAREZ',
        BARANGAY: 'TINIENTE TIAGO',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'A. DALUSAG',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'BATAS DAO',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'CASTANOS CERCA',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'CASTANOS LEJOS',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'KABULUSAN',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'KAYMISAS',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'KAYPAABA',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'LUMIPA',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'NARVAEZ',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'POBLACION IV',
    },
    {
        CITY: 'GENERAL-EMILIO-AGUINALDO',
        BARANGAY: 'TABORA',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'ALINGARO',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'ARNALDO POB. (BGY. 7)',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'BACAO I',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'BACAO II',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'BAGUMBAYAN POB. (BGY. 5)',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'BICLATAN',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'BUENAVISTA I',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'BUENAVISTA II',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'BUENAVISTA III',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'CORREGIDOR POB. (BGY. 10)',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'DULONG BAYAN POB. (BGY. 3)',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'GOV. FERRER POB. (BGY. 1)',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'JAVALERA',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'MANGGAHAN',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'NAVARRO',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'NINETY SIXTH POB. (BGY. 8)',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'PANUNGYANAN',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'PASONG CAMACHILE I',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'PASONG CAMACHILE II',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'PASONG KAWAYAN I',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'PASONG KAWAYAN II',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'PINAGTIPUNAN',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'PRINZA POB. (BGY. 9)',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'SAMPALUCAN POB. (BGY. 2)',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'SAN GABRIEL POB. (BGY. 4)',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'SAN JUAN I',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'SAN JUAN II',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'TAPIA',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'TEJERO',
    },
    {
        CITY: 'GENERAL-TRIAS',
        BARANGAY: 'VIBORA POB. (BGY. 6)',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ALAPAN I -A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ALAPAN I -B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ALAPAN I -C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ALAPAN I-A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ALAPAN I-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ALAPAN I-C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ALAPAN II-A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ALAPAN II-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I -A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I -B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I -C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I -D',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I -E',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I -F',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I -G',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I-A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I-C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I-D',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I-E',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I-F',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU I-G',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU II-A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU II-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU II-C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU II-D',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU II-E',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'ANABU II-F',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BAGONG SILANG (BAHAYANG PAG-ASA)',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BAYAN LUMA I',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BAYAN LUMA II',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BAYAN LUMA III',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BAYAN LUMA IV',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BAYAN LUMA IX',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BAYAN LUMA V',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BAYAN LUMA VI',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BAYAN LUMA VII',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BAYAN LUMA VIII',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BUCANDALA I',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BUCANDALA II',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BUCANDALA III',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BUCANDALA IV',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BUCANDALA V',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'BUHAY NA TUBIG',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'CARSADANG BAGO I',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'CARSADANG BAGO II',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MAGDALO',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MAHARLIKA',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I -A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I -B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I -C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I -D',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I -E',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I -F',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I -G',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I-A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I-C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I-D',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I-E',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I-F',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG I-G',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG II-A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG II-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG II-C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG II-D',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG II-E',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG II-F',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MALAGASANG II-G',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MARIANO ESPELETA I',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MARIANO ESPELETA II',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MARIANO ESPELETA III',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION I -A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION I -B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION I -C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION I -D',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION I-A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION I-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION I-C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION I-D',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION II-A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION II-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION II-C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION II-D',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION II-E',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'MEDICION II-F',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'PAG-ASA I',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'PAG-ASA II',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'PAG-ASA III',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'PALICO I',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'PALICO II',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'PALICO III',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'PALICO IV',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'PASONG BUAYA I',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'PASONG BUAYA II',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'PINAGBUKLOD',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION I -A (POB.)',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION I -B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION I -C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION I-A (POB.)',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION I-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION I-C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION II -A (POB.)',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION II -B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION II-A (POB.)',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION II-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION III-A (POB.)',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION III-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION IV-A (POB.)',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION IV-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION IV-C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'POBLACION IV-D',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TANZANG LUMA I',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TANZANG LUMA II',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TANZANG LUMA III',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TANZANG LUMA IV (SOUTHERN CITY)',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TANZANG LUMA V',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TANZANG LUMA VI',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TOCLONG I -A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TOCLONG I -B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TOCLONG I -C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TOCLONG I-A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TOCLONG I-B',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TOCLONG I-C',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TOCLONG II-A',
    },
    {
        CITY: 'IMUS',
        BARANGAY: 'TOCLONG II-B',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'AGUS-US',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'ALULOD',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'BANABA CERCA',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'BANABA LEJOS',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'BANCOD',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'BUNA CERCA',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'BUNA LEJOS I',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'BUNA LEJOS II',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'CALUMPANG CERCA',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'CALUMPANG LEJOS I',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'CARASUCHI',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'DAINE I',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'DAINE II',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'GUYAM MALAKI',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'GUYAM MUNTI',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'HARASAN',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'KAYQUIT I',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'KAYQUIT II',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'KAYQUIT III',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'KAYTAMBOG',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'KAYTAPOS',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'LIMBON',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'LUMAMPONG BALAGBAG',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'LUMAMPONG HALAYHAY',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'MAHABANGKAHOY CERCA',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'MAHABANGKAHOY LEJOS',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'MATAAS NA LUPA (CHECKPOINT)',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'PULO',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'TAMBO BALAGBAG',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'TAMBO ILAYA',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'TAMBO KULIT',
    },
    {
        CITY: 'INDANG',
        BARANGAY: 'TAMBO MALAKI',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'BALSAHAN-BISITA',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'BATONG DALIG',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'BINAKAYAN-APLAYA',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'BINAKAYAN-KANLURAN',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'CONGBALAY-LEGASPI',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'GAHAK',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'KAINGEN',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'MAGDALO (PUTOL)',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'MANGGAHAN-LAWIN',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'MARULAS',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'PANAMITAN',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'PULVORISTA',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'SAMALA-MARQUEZ',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'TABON I',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'TABON II',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'TABON III',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'TOCLONG',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'TRAMO-BANTAYAN',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'WAKAS I',
    },
    {
        CITY: 'KAWIT',
        BARANGAY: 'WAKAS II',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'BUCAL I',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'BUCAL II',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'BUCAL III A',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'BUCAL III B',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'BUCAL IV A',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'BUCAL IV B',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'CAINGIN POB. (BARANGAY 3)',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'GARITA I A',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'GARITA I B',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'LAYONG MABILOG',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'MABATO',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'PANTIHAN I (BALAYUNGAN)',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'PANTIHAN II (SAGBAT)',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'PANTIHAN III (POOK NA MUNTI)',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'PANTIHAN IV (POOK NI SARA)',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'PATUNGAN',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'PINAGSANHAN I A',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'PINAGSANHAN I B',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'POBLACION I A',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'POBLACION I B',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'POBLACION II A',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'POBLACION II B',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'SAN MIGUEL I A (CAPUTATAN)',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'SAN MIGUEL I B',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'TALIPUSNGO',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'TULAY KANLURAN',
    },
    {
        CITY: 'MARAGONDON',
        BARANGAY: 'TULAY SILANGAN',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'ANULING CERCA I',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'ANULING CERCA II',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'ANULING LEJOS I (ANULING)',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'ANULING LEJOS II',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'ASIS I',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'ASIS II',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'ASIS III',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'BANAYAD',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'GALICIA I',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'GALICIA II',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'GALICIA III',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'MIGUEL MOJICA',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'PALOCPOC I',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'PALOCPOC II',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'PANUNGYAN I',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'PANUNGYAN II',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'POBLACION I (BARANGAY I)',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'POBLACION II (BARANGAY II)',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'POBLACION III (BARANGAY III)',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'POBLACION IV (BARANGAY IV)',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'POBLACION V (BARANGAY V)',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'POBLACION VI (BARANGAY VI)',
    },
    {
        CITY: 'MENDEZ',
        BARANGAY: 'POBLACION VII (BARANGAY VII)',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'BAGONG KARSADA',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'BALSAHAN',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'BANCAAN',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'BUCANA MALAKI',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'BUCANA SASAHAN',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'CALUBCOB',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'CAPT. C. NAZARENO (POB.)',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'GOMEZ-ZAMORA (POB.)',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'HALANG',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'HUMBAC',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'IBAYO ESTACION',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'IBAYO SILANGAN',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'KANLURAN',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'LABAC',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'LATORIA',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'MABOLO',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'MAKINA',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'MALAINEN BAGO',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'MALAINEN LUMA',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'MOLINO',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'MUNTING MAPINO',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'MUZON',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'PALANGUE 1',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'PALANGUE 2 & 3',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'SANTULAN',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'SAPA',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'TIMALAN BALSAHAN',
    },
    {
        CITY: 'NAIC',
        BARANGAY: 'TIMALAN CONCEPCION',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'MAGDIWANG',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SALCEDO I',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SALCEDO II',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SAN ANTONIO I',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SAN ANTONIO II',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SAN JOSE I',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SAN JOSE II',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SAN JUAN I',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SAN JUAN II',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SAN RAFAEL I',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SAN RAFAEL II',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SAN RAFAEL III',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SAN RAFAEL IV',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SANTA ROSA I',
    },
    {
        CITY: 'NOVELETA',
        BARANGAY: 'SANTA ROSA II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'ACACIA',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'ADLAS',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'ANAHAW I',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'ANAHAW II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BALITE I',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BALITE II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BALUBAD',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BANABA',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BATAS',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BIGA I',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BIGA II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BILUSO',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BUCAL',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BUHO',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'BULIHAN',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'CABANGAAN',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'HOYO',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'HUKAY',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'IBA',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'INCHICAN',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'IPIL I',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'IPIL II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'KALUBKOB',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'KAONG',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'LALAAN I',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'LALAAN II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'LITLIT',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'LUCSUHIN',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'LUMIL',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'MAGUYAM',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'MALABAG',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'MALAKING TATYAO',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'MATAAS NA BUROL',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'MUNTING ILOG',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'NARRA I',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'NARRA II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'NARRA III',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'PALIGAWAN',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'PASONG LANGKA',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'POOC I',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'POOC II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'PULONG BUNGA',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'PULONG SAGING',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'PUTING KAHOY',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'SABUTAN',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'SAN MIGUEL I',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'SAN MIGUEL II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'SAN VICENTE I',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'SAN VICENTE II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'TARTARIA',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'TIBIG',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'TOLEDO',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'TUBUAN I',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'TUBUAN II',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'TUBUAN III',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'ULAT',
    },
    {
        CITY: 'SILANG',
        BARANGAY: 'YAKAL',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'ASISAN',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'BAGONG TUBIG',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'CALABUSO (CALABUSO SOUTH & NORTH)',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'DAPDAP EAST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'DAPDAP WEST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'FRANCISCO (SAN FRANCISCO)',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'GUINHAWA NORTH',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'GUINHAWA SOUTH',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'IRUHIN EAST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'IRUHIN SOUTH',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'IRUHIN WEST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'KAYBAGAL EAST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'KAYBAGAL NORTH',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'KAYBAGAL SOUTH (POB.)',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'MAG-ASAWANG ILAT',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'MAHARLIKA EAST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'MAHARLIKA WEST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'MAITIM 2ND CENTRAL',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'MAITIM 2ND EAST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'MAITIM 2ND WEST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'MENDEZ CROSSING EAST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'MENDEZ CROSSING WEST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'NEOGAN',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'PATUTONG MALAKI NORTH',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'PATUTONG MALAKI SOUTH',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'SAMBONG',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'SILANG JUNCTION NORTH',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'SILANG JUNCTION SOUTH',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'SUNGAY NORTH',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'SUNGAY SOUTH',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'TOLENTINO EAST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'TOLENTINO WEST',
    },
    {
        CITY: 'TAGAYTAY',
        BARANGAY: 'ZAMBAL',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'AMAYA I',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'AMAYA II',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'AMAYA III',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'AMAYA IV',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'AMAYA V',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'AMAYA VI',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'AMAYA VII',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'BAGTAS',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'BIWAS',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'BUCAL',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'CALIBUYO',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'CAPIPISA',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'DAANG AMAYA I',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'DAANG AMAYA II',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'DAANG AMAYA III',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'HALAYHAY',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'JULUGAN I',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'JULUGAN II',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'JULUGAN III',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'JULUGAN IV',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'JULUGAN V',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'JULUGAN VI',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'JULUGAN VII',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'JULUGAN VIII',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'LAMBINGAN',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'MULAWIN',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'PARADAHAN I',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'PARADAHAN II',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'PUNTA I',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'PUNTA II',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'SAHUD ULAN',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'SANJA MAYOR',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'TANAUAN',
    },
    {
        CITY: 'TANZA',
        BARANGAY: 'TRES CRUSES',
    },
    {
        CITY: 'TERNATE',
        BARANGAY: 'BUCANA',
    },
    {
        CITY: 'TERNATE',
        BARANGAY: 'POBLACION I (BARANGAY I)',
    },
    {
        CITY: 'TERNATE',
        BARANGAY: 'POBLACION I A',
    },
    {
        CITY: 'TERNATE',
        BARANGAY: 'POBLACION II (BARANGAY II)',
    },
    {
        CITY: 'TERNATE',
        BARANGAY: 'POBLACION III (BARANGAY III)',
    },
    {
        CITY: 'TERNATE',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TERNATE',
        BARANGAY: 'SAN JUAN I',
    },
    {
        CITY: 'TERNATE',
        BARANGAY: 'SAN JUAN II',
    },
    {
        CITY: 'TERNATE',
        BARANGAY: 'SAPANG I',
    },
    {
        CITY: 'TERNATE',
        BARANGAY: 'SAPANG II',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'AGUADO (PISCAL MUNDO)',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'CABEZAS',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'CABUCO',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'CONCHU (LAGUNDIAN)',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'DE OCAMPO',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'GREGORIO (ALIANG)',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'INOCENCIO (B. POOK)',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'LALLANA',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'LAPIDARIO (BAYOG)',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'LUCIANO (BITANGAN)',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'OSORIO',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'PEREZ (LUCBANAN)',
    },
    {
        CITY: 'TRECE-MARTIRES',
        BARANGAY: 'SAN AGUSTIN (POB.)',
    },
    {
        CITY: 'ANGONO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'ANGONO',
        BARANGAY: 'KALAYAAN',
    },
    {
        CITY: 'ANGONO',
        BARANGAY: 'MAHABANG PARANG',
    },
    {
        CITY: 'ANGONO',
        BARANGAY: 'POBLACION IBABA',
    },
    {
        CITY: 'ANGONO',
        BARANGAY: 'POBLACION ITAAS',
    },
    {
        CITY: 'ANGONO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ANGONO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'ANGONO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ANGONO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ANGONO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'BAGONG NAYON',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'BEVERLY HILLS',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'CALAWIS',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'CUPANG',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'DALIG',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'DELA PAZ (POB.)',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'INARAWAN',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'MAMBUGAN',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'MAYAMOT',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'MAYAMOT',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'MAYAMOT',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'MAYAMOT',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'MUNTINGDILAW',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'ANTIPOLO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'BANGAD',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'BATINGAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'BILIBIRAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'BINITAGAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'BOMBONG',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'BUHANGIN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'GINOONG SANAY',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'GULOD',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'HABAGATAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'ITHAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'JANOSA',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'KALAWAAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'KALINAWAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'KASILE',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'KAYTOME',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'KINABOOGAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'KINAGATAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'LAYUNAN (POB.)',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'LIBID (POB.)',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'LIBIS (POB.)',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'LIMBON-LIMBON',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'LUNSAD',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'MACAMOT',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'MAHABANG PARANG',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'MALAKABAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'MAMBOG',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'PALANGOY',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'PANTOK',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'PILA PILA',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'PINAGDILAWAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'PIPINDAN',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'RAYAP',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'SAPANG',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'TAGPOS',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'TATALA',
    },
    {
        CITY: 'BINANGONAN',
        BARANGAY: 'TAYUMAN',
    },
    {
        CITY: 'CAINTA',
        BARANGAY: 'SAN ANDRES (POB.)',
    },
    {
        CITY: 'CAINTA',
        BARANGAY: 'SAN ANDRES (POB.)',
    },
    {
        CITY: 'CAINTA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CAINTA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CAINTA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'CAINTA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CAINTA',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'CAINTA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'CAINTA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'BALIBAGO',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'BOOR',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'CALAHAN',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'DALIG',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'DEL REMEDIO (POB.)',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'IGLESIA (POB.)',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'LAMBAC',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'MALANGGAM-CALUBACAN',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'NAGSULO',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'NAVOTAS',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'PATUNHAY',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'REAL (POB.)',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'SAMPAD',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'SUBAY',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'TICULIO',
    },
    {
        CITY: 'CARDONA',
        BARANGAY: 'TUNA',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'BAGUMBONG',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'BAYUGO',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'FIRST (SPECIAL) DISTRICT (POB.)',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'LUBO',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'PAALAMAN',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'PAGKALINAWAN',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'PALAYPALAY',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'SECOND DISTRICT (POB.)',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'SIPSIPIN',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'SPECIAL DISTRICT (POB.)',
    },
    {
        CITY: 'JALA-JALA',
        BARANGAY: 'THIRD DISTRICT (POB.)',
    },
    {
        CITY: 'PILILLA',
        BARANGAY: 'BAGUMBAYAN (POB.)',
    },
    {
        CITY: 'PILILLA',
        BARANGAY: 'HALAYHAYIN',
    },
    {
        CITY: 'PILILLA',
        BARANGAY: 'HULO (POB.)',
    },
    {
        CITY: 'PILILLA',
        BARANGAY: 'IMATONG (POB.)',
    },
    {
        CITY: 'PILILLA',
        BARANGAY: 'MALAYA',
    },
    {
        CITY: 'PILILLA',
        BARANGAY: 'NIOGAN',
    },
    {
        CITY: 'PILILLA',
        BARANGAY: 'QUISAO',
    },
    {
        CITY: 'PILILLA',
        BARANGAY: 'TAKUNGAN (POB.)',
    },
    {
        CITY: 'PILILLA',
        BARANGAY: 'WAWA (POB.)',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'EVANGELISTA',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'PINUGAY',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'SAN SALVADOR',
    },
    {
        CITY: 'BARAS',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'BOMBONGAN',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'CAN-CAL-LAN (CANIOGAN-CALERO-LANANG)',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'LAGUNDI',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'MAYBANCAL',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'SAN GUILLERMO',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'AMPID I',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'AMPID II',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BANABA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'DULONG BAYAN 1',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'DULONG BAYAN 2',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'GUINAYANG',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'GUITNANG BAYAN I (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'GUITNANG BAYAN II (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'GULOD MALAYA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'MALANDAY',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'MALY',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'PINTONG BOCAWE',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SILANGAN',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'DOLORES (POB.)',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'MUZON',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'BALITE (POB.)',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'GERONIMO',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'MACABUD',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'MANGGAHAN',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'MASCAP',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'PURAY',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'RODRIGUEZ',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'CAYABU',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'CUYAMBAY',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'DARAITAN',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'KATIPUNAN-BAYAN (POB.)',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'KAYBUTO (POB.)',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'LAIBAN',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'MADILAY-DILAY',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'MAG-AMPON (POB.)',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'MAMUYAO',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'PINAGKAMALIGAN (POB.)',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'PLAZA ALDEA (POB.)',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'SANTA INEZ',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'TABING ILOG (POB.)',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'TANDANG KUTYO (POB.)',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'TINUCAN',
    },
    {
        CITY: 'TANAY',
        BARANGAY: 'WAWA (POB.)',
    },
    {
        CITY: 'TERESA',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TERESA',
        BARANGAY: 'CALUMPANG SANTO CRISTO',
    },
    {
        CITY: 'TERESA',
        BARANGAY: 'DALIG',
    },
    {
        CITY: 'TERESA',
        BARANGAY: 'DULUMBAYAN',
    },
    {
        CITY: 'TERESA',
        BARANGAY: 'MAY-IBA',
    },
    {
        CITY: 'TERESA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TERESA',
        BARANGAY: 'PRINZA',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'PALMA',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN BENITO',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN ILDEFONSO',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'BITIN',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'CALO',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'DILA',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'MAITIM',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'MASAYA',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'PACIANO RIZAL',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'PUYPUY',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'SAN AGUSTIN (POB.)',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'BAY',
        BARANGAY: 'TRANCA',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'BINAN (POBLACION)',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'BUNGAHAN',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'CANLALAY',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'CASILE',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'DE LA PAZ',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'GANADO',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'LANGKIWA',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'LOMA',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'MALABAN',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'MALAMIG',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'MAMPALASAN',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'PLATERO',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'SAN FRANCISCO (HALANG)',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'SANTO TOMAS (CALABUSO)',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'SORO-SORO',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'TIMBAO',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'TUBIGAN',
    },
    {
        CITY: 'BINAN',
        BARANGAY: 'ZAPOTE',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'BACLARAN',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'BANAYBANAY',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'BANLIC',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'BARANGAY DOS (POB.)',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'BARANGAY TRES (POB.)',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'BARANGAY UNO (POB.)',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'BIGAA',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'BUTONG',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'CASILE',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'DIEZMO',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'GULOD',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'MAMATID',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'MARINIG',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'NIUGAN',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'PITTLAND',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'PULO',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'SALA',
    },
    {
        CITY: 'CABUYAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BAGONG KALSADA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BANADERO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BANLIC',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BARANDAL',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BATINO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BATINO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BATINO WAREHOUSE',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BUBUYAN',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BUCAL',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BUNGGO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BUROL',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'CAMALIGAN',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'CANLUBANG',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'CANLUBANG',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'CANLUBANG',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'HALANG',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'HORNALAN',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'KAY-ANLOG',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'LA MESA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'LAGUERTA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'LAWA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'LECHERIA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'LINGGA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MABATO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MAJADA LABAS',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MAKILING',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MAPAGONG',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MASILI',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MAUNONG',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MAYAPA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MILAGROSA (TULO)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'PACIANO RIZAL',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'PALINGON',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'PALO-ALTO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'PANSOL',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'PARIAN',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'PRINZA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'PUTING LUPA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'REAL',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SAIMSIM',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SAMPIRUHAN',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SAN CRISTOBAL',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SIRANG LUPA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SUCOL',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'TURBINA',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'ULANGO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'UWISAN',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'BALAYHANGIN',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'BANGYAS',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'DAYAP',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'HANGGAN',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'IMOK',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'KANLURAN (POB.)',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'LAMOT 1',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'LAMOT 2',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'LIMAO',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'MABACAN',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'MASIIT',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'PALIPARAN',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'PEREZ',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'PRINZA',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'CALAUAN',
        BARANGAY: 'SILANGAN (POB.)',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'ANGLAS',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'BANGCO',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'BULAJO',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'CANSUSO',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'DUHAT',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'INAO-AWAN',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'KANLURAN TALAONGAN',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'LABAYO',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'LAYASIN',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'LAYUG',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'MAHIPON',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'PAOWIN',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'SILANGAN TALAONGAN',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'SISILMIN',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'SUMUCAB',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'TIBATIB',
    },
    {
        CITY: 'CAVINTI',
        BARANGAY: 'UDIA',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'ASANA (POB.)',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'BACONG-SIGSIGAN',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'BAGONG PAG-ASA (POB.)',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'BALITOC',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'BANABA (POB.)',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'BATUHAN',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'BULIHAN',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'CABALLERO (POB.)',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'CALUMPANG (POB.)',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'CUEBANG BATO',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'DAMAYAN (POB.)',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'KAPATALAN',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'KATAYPUANAN',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'LIYANG',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'MAATE',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'MAGDALO (POB.)',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'MAYATBA',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'MINAYUTAN',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'SALANGBATO',
    },
    {
        CITY: 'FAMY',
        BARANGAY: 'TUNHAC',
    },
    {
        CITY: 'KALAYAAN',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'KALAYAAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'KALAYAAN',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'EAST POBLACION',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'ENTABLADO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'LAGUAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'PAULE 1',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'PAULE 2',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'POOK',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'TALA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'TALAGA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'TUY',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'WEST POBLACION',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'ALIPIT',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BUBUKAL',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'CALIOS',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'DUHAT',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'GATID',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'JASAAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LABUIN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'OOGONG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PAGSAWITAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PALASAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PATIMBAO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN PABLO NORTE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN PABLO SUR',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SANTISIMA CRUZ',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SANTO ANGEL CENTRAL',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SANTO ANGEL NORTE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SANTO ANGEL SUR',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'ADIA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BAGONG POOK',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BUBUKAL',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CABOOAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CALANGAY',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CAMBUJA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CORALAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CUEVA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'INAYAPAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'JOSE LAUREL',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'JOSE LAUREL SR.',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'JOSE RIZAL',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'KAYHAKAT',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MACASIPAC',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MASINAO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MATALING-TING',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'PAO-O',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'PARANG NG BUHO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'TALANGKA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'TUNGKOD',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BANCA-BANCA',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'DANIW',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'MASAPANG',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'NANHAYA (POB.)',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'PAGALANGAN',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN BENITO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN FELIX',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'BAGONG ANYO (POB.)',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'BAYATE',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'BONGKOL',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'BUBUKAL',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'CABUYAO',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'CULOY',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'DAGATAN',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'DANIW (DANLIW)',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'DITA',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'IBABANG PALINA',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'IBABANG SAN ROQUE',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'IBABANG SUNGI',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'IBABANG TAYKIN',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'ILAYANG PALINA',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'ILAYANG SAN ROQUE',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'ILAYANG SUNGI',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'ILAYANG TAYKIN',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'KANLURANG BUKAL',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'LAGUAN',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'LUQUIN',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'MALABO-KALANTUKAN',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'MASIKAP (POB.)',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'MASLUN (POB.)',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'MOJON',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'NOVALICHES',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'OPLES',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'PAG-ASA (POB.)',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'PALAYAN',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'SILANGANG BUKAL',
    },
    {
        CITY: 'LILIW',
        BARANGAY: 'TUY-BAANAN',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'ANOS',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'BAMBANG',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'BATONG MALAKE',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'BAYBAYIN (POB.)',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'BAYOG',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'LALAKAY',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'MAAHAS',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'MALINTA',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'MAYONDON',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'PUTHO TUNTUNGIN',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'TADLAK',
    },
    {
        CITY: 'LOS-BANOS',
        BARANGAY: 'TIMUGAN (POB.)',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'BARANGAY ZONE I (POB.)',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'BARANGAY ZONE II (POB.)',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'BARANGAY ZONE III (POB.)',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'BARANGAY ZONE IV (POB.)',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'BARANGAY ZONE V (POB.)',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'BARANGAY ZONE VI (POB.)',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'BARANGAY ZONE VII (POB.)',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'BARANGAY ZONE VIII (POB.)',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'DE LA PAZ',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN BUENAVENTURA',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN DIEGO',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SAN SALVADOR',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'LUISIANA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'BALIMBINGAN (POB.)',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'BALUBAD',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'CALIRAYA',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'LEWIN',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'MARACTA (POB.)',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'MAYTALANG I',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'MAYTALANG II',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'PRIMERA PARANG (POB.)',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'PRIMERA PULO (POB.)',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'SALAC (POB.)',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'SEGUNDA PARANG (POB.)',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'SEGUNDA PULO (POB.)',
    },
    {
        CITY: 'LUMBAN',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'AMUYONG',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'BAYANIHAN (POB.)',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'LAMBAC (POB.)',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'LIBIS NG NAYON (POB.)',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'LUCONG',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'MALIGAYA (POB.)',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'MASIKAP (POB.)',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'MATALATALA',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'NANGUMA',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'NUMERO',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'PAAGAHAN',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'PAG-ASA (POB.)',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MABITAC',
        BARANGAY: 'SINAGTALA (POB.)',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'ALIPIT',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'BAANAN',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'BALANAC',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'BUCAL',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'BUNGKOL',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'BUO',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'BURLUNGAN',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'CIGARAS',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'HALAYHAYIN',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'IBABANG ATINGAY',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'IBABANG BUTNONG',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'ILAYANG ATINGAY',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'ILAYANG BUTNONG',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'ILOG',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'MALAKING AMBLING',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'MARAVILLA',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'MUNTING AMBLING',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'SALASAD',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'TANAWAN',
    },
    {
        CITY: 'MAGDALENA',
        BARANGAY: 'TIPUNAN',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'AMONOY',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'BAKIA',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'BALANAC',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'BALAYONG',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'BANILAD',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'BANTI',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'BITAOY',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'BOTOCAN',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'BUROL',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'CORALAO',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'GAGALOT',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'IBABANG BANGA',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'IBABANG BAYUCAIN',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'ILAYANG BANGA',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'ILAYANG BAYUCAIN',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'ISABANG',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'MAY-IT',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'MUNTING KAWAYAN',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'OLLA',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'OOBI',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'ORIGUEL (POB.)',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'PANALABAN',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'PANGIL',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'PANGLAN',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'PIIT',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'POOK',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'SAN MIGUEL (POB.)',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'SANTA CATALINA (POB.)',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'TALORTOR',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'TANAWAN',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'MAJAYJAY',
        BARANGAY: 'VILLA NOGALES',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'ABO',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'ALIBUNGBUNGAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'ALUMBRADO',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BALAYONG',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BALIMBING',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BALINACON',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BAMBANG',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BANAGO',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BANCA-BANCA',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BANGCURO',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BANILAD',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BAYAQUITOS',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BUBOY',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BUHANGINAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'CABUYEW',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'KANLURAN KABUBUHAYAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'KANLURAN LAZAAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'LABANGAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'LAGULO',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'LAWAGUIN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'MAIIT',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'MALAYA',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'MANAOL',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'MARAVILLA',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'NAGCALBANG',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'OPLES',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'PALAYAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'PALINA',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'POBLACION I (POB.)',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'POBLACION II (POB.)',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'POBLACION III (POB.)',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'SIBULAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'SILANGAN ILAYA',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'SILANGAN KABUBUHAYAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'SILANGAN LAZAAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'SILANGAN NAPAPATID',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'SINIPIAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'SULSUGUIN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'TALAHIB',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'TALANGAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'TIPACAN',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'WAKAT',
    },
    {
        CITY: 'NAGCARLAN',
        BARANGAY: 'YUKOS',
    },
    {
        CITY: 'PAETE',
        BARANGAY: 'BAGUMBAYAN (POB.)',
    },
    {
        CITY: 'PAETE',
        BARANGAY: 'BANGKUSAY (POB.)',
    },
    {
        CITY: 'PAETE',
        BARANGAY: 'ERMITA (POB.)',
    },
    {
        CITY: 'PAETE',
        BARANGAY: 'IBABA DEL NORTE (POB.)',
    },
    {
        CITY: 'PAETE',
        BARANGAY: 'IBABA DEL SUR (POB.)',
    },
    {
        CITY: 'PAETE',
        BARANGAY: 'ILAYA DEL NORTE (POB.)',
    },
    {
        CITY: 'PAETE',
        BARANGAY: 'ILAYA DEL SUR (POB.)',
    },
    {
        CITY: 'PAETE',
        BARANGAY: 'MAYTOONG (POB.)',
    },
    {
        CITY: 'PAETE',
        BARANGAY: 'QUINALE (POB.)',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'ANIBONG',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'BINAN',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'BUBOY',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'CABANBANAN',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'CALUSICHE',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'DINGIN',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'LAMBAC',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'LAYUGAN',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'MAGDAPIO',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'MAULAWIN',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'PINAGSANJAN',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'PAGSANJAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'BANILAN',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'BANO (POB.)',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'BURGOS (POB.)',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'CASA REAL',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'CASINSIN',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'DORADO',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'GONZALES (POB.)',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'KABULUSAN',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'MATIKIW',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'SARAY',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'TAFT (POB.)',
    },
    {
        CITY: 'PAKIL',
        BARANGAY: 'TAVERA (POB.)',
    },
    {
        CITY: 'PANGIL',
        BARANGAY: 'BALIAN',
    },
    {
        CITY: 'PANGIL',
        BARANGAY: 'DAMBO',
    },
    {
        CITY: 'PANGIL',
        BARANGAY: 'GALALAN',
    },
    {
        CITY: 'PANGIL',
        BARANGAY: 'ISLA (POB.)',
    },
    {
        CITY: 'PANGIL',
        BARANGAY: 'MABATO-AZUFRE',
    },
    {
        CITY: 'PANGIL',
        BARANGAY: 'NATIVIDAD (POB.)',
    },
    {
        CITY: 'PANGIL',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'PANGIL',
        BARANGAY: 'SULIB',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'APLAYA',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'BAGONG POOK',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'BULILAN NORTE (POB.)',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'BULILAN SUR (POB.)',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'LABUIN',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'LINGA',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'MASICO',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'MOJON',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'PANSOL',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'PINAGBAYANAN',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'SANTA CLARA NORTE (POB.)',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'SANTA CLARA SUR (POB.)',
    },
    {
        CITY: 'PILA',
        BARANGAY: 'TUBUAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'ATISAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BAGONG BAYAN II-A (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BAGONG POOK VI-C (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY I-A (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY I-B (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY II-A (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY II-B (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY II-C (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY II-D (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY II-E (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY II-F (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY III-A (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY III-B (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY III-C (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY III-D (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY III-E (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY III-F (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY IV-A (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY IV-B (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY IV-C (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY V-A (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY V-B (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY V-C (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY V-D (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY VI-A (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY VI-B (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY VI-D (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY VI-E (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY VII-A (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY VII-B (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY VII-C (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY VII-D (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BARANGAY VII-E (POB.)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BAUTISTA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'DEL REMEDIO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN ANTONIO 1',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN ANTONIO 2',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN BARTOLOME',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN BUENAVENTURA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN CRISPIN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN CRISTOBAL',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN DIEGO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN IGNACIO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN LUCAS 1',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN LUCAS 2',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTA FELOMINA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTA MARIA MAGDALENA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTA VERONICA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTIAGO I',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTIAGO II',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTISIMO ROSARIO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTO ANGEL',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SOLEDAD',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'CALENDOLA',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'CHRYSANTHEMUM',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'CUYAB',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'G.S.I.S.',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'LANDAYAN',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'LANGGAM',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'LARAM',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'MAHARLIKA',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'NARRA',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'NUEVA',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'PACITA 1',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'PACITA 2',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'RIVERSIDE',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'SAMPAGUITA VILLAGE',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'SAN LORENZO RUIZ',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'UNITED BAYANIHAN',
    },
    {
        CITY: 'SAN-PEDRO',
        BARANGAY: 'UNITED BETTER LIVING',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'APLAYA',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'BALIBAGO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'CAINGIN',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'DILA',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'DITA',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'DON JOSE',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'IBABA',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'KANLURAN (POB.)',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'LABAS',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'MACABLING',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'MALITLIT',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'MALUSAK (POB.)',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'MARKET AREA (POB.)',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'POOK',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'PULONG SANTA CRUZ',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SINALHAN',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'TAGAPO',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'ACEVIDA',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'BAGONG PAG-ASA (POB.)',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'BAGUMBARANGAY (POB.)',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'BUHAY',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'G. REDOR (POB.)',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'GEN. LUNA',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'HALAYHAYIN',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'J. RIZAL (POB.)',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'KAPATALAN',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'LAGUIO',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'LIYANG',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'LLAVAC',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'MACATAD',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'MAYATBA',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'MENDIOLA',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'P. BURGOS',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'PANDENO',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'SALUBUNGAN',
    },
    {
        CITY: 'SINILOAN',
        BARANGAY: 'WAWA',
    }
];
